import { createSimpleForm } from 'pages/common/Form';
import { createItemPage } from 'pages/common/ItemPage';

import { selectors, actions } from 'domain/substrate';
import { createFormConfig } from 'lib/helpers';

import { columns } from 'fields/substrate';

const { item } = selectors;
const { updateItemAction } = actions;

export const editableFields = ['description', 'order', 'rank', 'values'];

export default createItemPage({
  name: 'substrate',
  connections: {
    item,
  },
  titleFn: data => data.get('description'),
  config: {
    basicInfo: [
      createFormConfig(columns.select(...editableFields)),
      [],
      columns.select('id','createdDate','updatedDate'),
    ],
  },
  Form: createSimpleForm({
    form: 'substrateForm',
    action: updateItemAction,
  }),
});
